import {config} from "../environment";
import {useAsync} from "../utils/utils";
import {ApiError, ApiErrorResponse} from "./apiError";

type PlasseringerResponse = {
  plasseringer: Array<Plassering>
}

export type Plassering = {
  id: number,
  barnehageNavn: string,
  avdelingNavn: string,
  plasstype: string,
  barnIdent: string,
  barnFornavn: string,
  barnEtternavn: string,
  startDato: string,
  sluttDato?: string,
  kanSiOpp: boolean,
  harSøktOppsigelse: boolean,
  kanSøkePermisjon: boolean,
  harSøktPermisjon: boolean,
  oppsigelseGodkjent: boolean,
}

type Oppsigelsesgrunn = {
  beskrivelse: string
  id: number
}

type OppsigelsesgrunnerResponse = {
  oppsigelsesgrunner: Array<Oppsigelsesgrunn>
}

async function getPlasseringer(): Promise<Array<Plassering>> {
  return fetch(`${config.apiUrl}/api/barnehageplass/plasseringer`)
  .then(async res => {
    if (!res.ok) {
      const apiError: ApiErrorResponse = await res.json()
      throw new ApiError(`Klarte ikke hente plasseringer`, apiError)
    }
    const json: PlasseringerResponse = await res.json()
    return json.plasseringer
  })
}

async function getOppsigelsesgrunner(plasseringId: number) {
  return fetch(`${config.apiUrl}/api/barnehageplass/plasseringer/${plasseringId}/oppsigelsesgrunner`)
  .then(async res => {
    if (!res.ok) {
      throw new Error(`Klarte ikke hente Oppsigelsesgrunner: ${res.status} ${res.statusText}`)
    }
    return res
  })
  .then(res => res.json() as Promise<OppsigelsesgrunnerResponse>)
  .then(json => json.oppsigelsesgrunner)
}

export const usePlasseringer = useAsync(getPlasseringer)
export const useOppsigelsesgrunner = useAsync(getOppsigelsesgrunner, false)